<div class="search-widget">
  @if (buttonMode) {
    <button
      mb-button
      mb-button-fullwidth
      (click)="openDialog()"
      variant="principal"
      color="primary"
    >
      @if (modify) {
        <span>Modificar búsqueda</span>
      } @else {
        <span>Elegir fechas</span>
      }
    </button>
  } @else {
    <search-status [items]="statusItems" [show]="showStatus" (click)="openDialog()"></search-status>
    <div name="searchform" class="am-ctn am-ctn--gtr">
      <div class="am-ctn am-ctn--xxl am-ctn--gtr">
        <am-search-box
          class="am-search-box"
          [ngClass]="{ 'hide-autocomplete': isLanding }"
          [brand]="brand"
          [channel]="channel"
          [product]="'hotels'"
          [initialData]="initialData"
          [dataType]="'model'"
          [allowDollar]="allowDollar"
          [disableARS]="disableARS"
          (modelSearch)="handleSearch($event)">
        </am-search-box>
      </div>
    </div>
  }
</div>

<ng-template #searchBoxTemplate let-dialogRef>
  <mb-dialog class="search-box-dialog full-dialog">
    <mb-dialog-header [showCloseBtn]="true" (closeDialog)="dialogRef.close()">
    </mb-dialog-header>
    <mb-dialog-body class="search-box-dialog__body">
      <am-search-box
        class="am-search-box"
        [ngClass]="{'hide-autocomplete': isLanding}"
        [brand]="brand"
        [channel]="channel"
        [product]="'hotels'"
        [initialData]="initialData"
        [dataType]="'model'"
        [allowDollar]="allowDollar"
        [disableARS]="disableARS"
        (modelSearch)="handleSearch($event)">
      </am-search-box>
    </mb-dialog-body>
  </mb-dialog>
</ng-template>
